import { createSelector } from 'reselect'

const getState = state => state.SchoolFiles

const getFetchSchoolFilesRequest = state =>
  getState(state).fetchSchoolFilesRequest

const getSchoolFiles = state => getState(state).schoolFiles

const getSchoolFilesResult = createSelector(
  [getSchoolFiles],
  schoolFiles => (!schoolFiles ? [] : schoolFiles.result)
)

const getSchoolFilesMap = createSelector(
  [getSchoolFiles],
  schoolFiles => (!schoolFiles ? {} : schoolFiles.entities.schoolFiles)
)

const getSchoolFilesList = createSelector(
  [getSchoolFilesResult, getSchoolFilesMap],
  (result, schoolFilesMap) => result.map(id => schoolFilesMap[id])
)

const getSchoolFile = (state, id) => getSchoolFilesMap(state)[id]

const getFilter = state => state.SchoolFiles.filter

const getServerFilterParams = createSelector(
  [getFilter],
  filter => {
    let filters = {
      search_string: filter.title,
      benchmarked: filter.benchmarked,
      owner_name: filter.owner,
      ...(filter.judgement && { judgement: filter.judgement }),
      ...(filter.moderationType && { moderation_type: filter.moderationType }),
      ...(filter.yearGroup && { 'year_group_ids[]': filter.yearGroup })
      /*limit: filter.currentLimit,*/
    }
    return filters
  }
)

const getFetchSchoolFilesRequestInitiator = createSelector(
  [getFetchSchoolFilesRequest],
  req => (!req.params ? null : req.params.initiator)
)

export {
  getSchoolFiles,
  getSchoolFilesList,
  getFetchSchoolFilesRequest,
  getSchoolFile,
  getFilter,
  getServerFilterParams,
  getFetchSchoolFilesRequestInitiator
}
